/** 表示言語の決定（純粋）。保存された選択を最優先し、なければブラウザの言語、それもなければ既定 */
import { DEFAULT_LANGUAGE_ID, LANGUAGE_IDS, LANGUAGES, type LanguageId } from '../config/languages';

export const isLanguageId = (value: unknown): value is LanguageId => typeof value === 'string' && (LANGUAGE_IDS as readonly string[]).includes(value);

/** ブラウザの言語（優先順）から、対応する最初の言語を返す。対応がなければ null */
export function languageFromPreferred(preferred: readonly string[]): LanguageId | null {
  for (const tag of preferred) {
    const lower = tag.toLowerCase();
    const found = LANGUAGE_IDS.find((id) => LANGUAGES[id].matches.some((prefix) => lower === prefix || lower.startsWith(`${prefix}-`)));
    if (found) return found;
  }
  return null;
}

/** stored: 保存された値（外から来るので unknown）、preferred: navigator.languages */
export function resolveLanguage(stored: unknown, preferred: readonly string[]): LanguageId {
  if (isLanguageId(stored)) return stored;
  return languageFromPreferred(preferred) ?? DEFAULT_LANGUAGE_ID;
}
